@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/screen-width-breakpoints.module.less';

.new-manual-order-modal {
  margin: 30px 0;

  @media @tablet {
    width: 561px;
  }

  @media @desktop, @widescreen, @ultrawide {
    width: 1000px;
  }
}

.new-order-modal-header {
  background-color: @new-order-modal--header--background-color;
  box-shadow: 0 1px 1px @new-order-modal--header--box-shadow-color;
  color: @new-order-modal--header--text-color;
}

.new-manual-order-modal-footer {
  display: flex;
  justify-content: flex-end;
}

.button-container {
  display: flex;
  padding-left: 10px;
}

.right-buttons {
  display: flex;
  align-items: center;
}

.button-styles {
  font-size: 12px;
  border-right: 1px solid var(--white);
  display: flex;
}

.dropdown-item {
  font-weight: @bold;
}

.dropdown-menu {
  max-width: none;
}

.drop-down-menu-button {
  border-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  padding: 0;
}

.order-content {
  display: flex;
  flex-direction: column;

  .section-title {
    font-weight: @bold;
    font-size: 14px;
    padding-bottom: 10px;
  }

  .recipient-and-order-summary-container {
    display: flex;

    @media @mobile, @tablet {
      flex-direction: column;
    }

    .recipient-information-container {
      flex: 3;
      padding: 20px;

      @media @mobile, @tablet {
        padding: 20px 10px;
      }
    }

    .order-summary-container {
      flex: 2;
      padding: 20px;
      min-height: 400px;
      background-color: @new-order-modal--order-summary-container--background-color;

      @media @mobile, @tablet {
        padding: 20px 10px;
      }
    }
  }

  .order-items-container {
    border-top: 1px solid @new-order-modal--items--border-color;

    .order-items-title {
      padding: 15px 20px;
    }
  }
}

.loading-indicator {
  height: 584px;
}
